<template>
<div>  
  <main class="container-fluid">
    <div class='row heading'>
      <div class='col-4 px-3 pt-3 d-none d-md-flex'></div> 
      <div class='col-16 px-3 pt-3'>
        <h1 class="title pt-2 mb-0" v-text="$ml.get('support')">Suporte!</h1>
        <h1 class="title"><span class="pb-2" v-text="$ml.get('talkDirectlyToOurOperators')">Fale diretamente com nossos operadores.</span></h1>  
      </div>
    </div>

    <section class='row justify-content-start'> 
      <div class='col-4 px-3 pb-3 align-self-start'></div>

  <!-- Início do menu mobile -->

      <b-sidebar 
        ref="sidebarMenu"
        id="sidebar-menu" 
        no-header 
        backdrop-variant="dark" 
        backdrop 
        shadow
        width='220px'
      > 

        <div class='card-header d-flex justify-content-between'>
          <a>Wiki</a>
          <a class="pointer row justify-content-start" @click="closeSidebarMenu" role="button">
            <img src="../../src/assets/icons/times-circle.svg" class="ico-15"/> 
          </a>  
        </div>
    
        <aside class=' mt-1 pb-2'>  
          <ul class="none-p-m">
            <li class='pb-2'>
              <a v-text="$ml.get('contacts')">
                Contatos
              </a>
              <ul class='none-p-m pt-2 pb-3'>
                <li :class="this.menuSelected == 'aboutUs' ? 'active py-1' :'py-1'">
                  <i><img src="../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="alterMenu('aboutUs')" v-text="$ml.get('aboutUs')">
                    Sobre nós
                  </a>
                </li>
                <li :class="this.menuSelected == 'contacts' ? 'active py-1' :'py-1'">
                  <i><img src="../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="alterMenu('contacts')" v-text="$ml.get('contacts')">
                    Contatos
                  </a>
                </li>  
              </ul>
            </li> 
          </ul> 
        </aside> 
      </b-sidebar> 
 
      <a id="btn-float-mobile" class="d-md-none btn" v-b-toggle.sidebar-menu role="button">
        <svg width="20" height="20" class="mb-1">       
          <image xlink:href="../../src/assets/icons/bars.svg" width="20" height="20"/>    
        </svg>
      </a>  
  <!-- Fim -->
 
      <aside class='col-4 pb-3 d-none d-md-flex'>  
        <ul class="none-p-m">
          <li class='pb-2'>
            <a v-text="$ml.get('contacts')">
              Contatos
            </a>
            <ul class='none-p-m pt-2 pb-3'>
              <li :class="this.menuSelected == 'aboutUs' ? 'active py-1' :'py-1'">
                <i><img src="../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('aboutUs')" v-text="$ml.get('aboutUs')">
                  Sobre nós
                </a>
              </li>
              <li :class="this.menuSelected == 'contacts' ? 'active py-1' :'py-1'">
                <i><img src="../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('contacts')" v-text="$ml.get('contacts')">
                  Contatos
                </a>
              </li> 
            </ul>
          </li> 
        </ul>
      </aside> 

      <div class='col-24 px-3 col-md-12 pb-3 mb-5'>
        <div class='col d-flex flex-column w-100 align-self-start'>
          <div class='card mb-3'>
           <about-us v-if="menuSelected == 'aboutUs'"/>
           <contacts v-if="menuSelected == 'contacts'"/>
          </div>
        </div> 
      </div>

    </section> 
  </main>
</div>
</template>

<script>
import AboutUs from "./suport/aboutUs.vue"  
import Contacts from "./suport/contacts.vue"  

export default {
  components: {
    AboutUs,
    Contacts,
  },
  data() {
    return {
      title: "Suport", 
      menuSelected: 'aboutUs',
    };
  }, 
  methods: {
    closeSidebarMenu(){
      this.$refs.sidebarMenu.hide(); 
    },
    alterMenu(menu) {
      this.menuSelected = menu;
      this.closeSidebarMenu();
    },
  },
};
</script> 
<style scoped>
.active{
  color: #E10E71 !important; 
}
.active > a{ 
  font-weight: 500;
}
a{
  cursor: pointer;
}
a:active{
  color: #E10E71 !important;
}
</style>